export const videoFormatList = [
  "261",
  "263",
  "264",
  "265",
  "3g2",
  "3gp",
  "4xm",
  "amv",
  "anim",
  "asf",
  "avc",
  "avi",
  "avs",
  "bfi",
  "bik",
  "bin",
  "bk2",
  "bmv",
  "c93",
  "cak",
  "cavs",
  "cdxl",
  "cgi",
  "chk",
  "cif",
  "cin",
  "cine",
  "cmv",
  "cpk",
  "dct",
  "dfa",
  "dif",
  "divx",
  "dnxhd",
  "dnxhr",
  "drc",
  "dv",
  "dvd",
  "dxa",
  "f4v",
  "film",
  "flm",
  "flv",
  "gdv",
  "gxf",
  "h261",
  "h263",
  "h264",
  "h265",
  "h26l",
  "hevc",
  "hnm",
  "idcin",
  "iv8",
  "ivf",
  "ivr",
  "j2k",
  "jv",
  "lvf",
  "lxf",
  "m1v",
  "m2t",
  "m2ts",
  "m2v",
  "m3u8",
  "m4v",
  "mad",
  "mgsts",
  "mj2",
  "mjpeg",
  "mjpg",
  "mk3d",
  "mkv",
  "mlv",
  "mm",
  "mov",
  "mp4",
  "mpd",
  "mpeg",
  "mpg",
  "mpo",
  "mts",
  "mtv",
  "mv",
  "mve",
  "mvi",
  "mvi1",
  "mvi2",
  "mxf",
  "mxg",
  "nsv",
  "nut",
  "nuv",
  "ogg",
  "ogm",
  "ogv",
  "ogx",
  "paf",
  "pmp",
  "pva",
  "qcif",
  "r3d",
  "rcv",
  "rgb",
  "rl2",
  "rm",
  "rmvb",
  "roq",
  "rpl",
  "san",
  "sanm",
  "sdr2",
  "seq",
  "smk",
  "snd",
  "str",
  "swf",
  "tgi",
  "tgq",
  "tgv",
  "thp",
  "tmv",
  "ts",
  "ty",
  "ty+",
  "uv",
  "uv2",
  "v",
  "v210",
  "vb",
  "vc1",
  "vc2",
  "vcd",
  "vid",
  "viv",
  "vmd",
  "vp6",
  "vqa",
  "wc3movie",
  "webm",
  "wmv",
  "wtv",
  "wve",
  "xl",
  "xml",
  "xmv",
  "y4m",
  "yop",
  "yuv",
  "yuv10"
]

export const imageList = [
  "jpg",
  "jpeg",
  "jfif",
  "pjp",
  "pjpeg",
  "bmp",
  "png",
  "apng",
  "avif",
  "tif",
  "tiff",
  "webp"
]

export const compressedList = [
  'zip',
  '7z',
  'rar',
  'tar',
  'gzip',
  'bzip2',
  'xz',
  'lzip',
  'dmg',
  'iso',
  'brotli',
  'zstd',
  'lrzip',
  'win',
  'war',
  'ipa',
  'xip',
  'apk',
  'appx',
  'xpi',
  'cpgz',
  'cpio'
]

export const musicList=[
  'acc',
  'flac',
  'ogg',
  'wma',
  'flac',
  'mp3',
  'wav',
  'pcm',
  'aiff',
  'alac',
  'm4a'
]